export const MarketingEventsDepartmentsGridPluginSettings: IPluginSettings = {
    name: 'Департаменты маркетинговых мероприятий',
    mnemocode: 'marketing_events_departments_plugin',
    permission: 'MarketingEvents',
    columns: (() => {
        let index = 0;
        return [
            {
                order: index++,
                propertyName: 'contractorName',
                propertyType: 'string',
                displayName: 'Департамент',
                visibility: true,
                width: 300
            },
            {
                order: index++,
                propertyName: 'legalEntityName',
                propertyType: 'string',
                displayName: 'Контрагент',
                visibility: true,
                width: 300
            },
            {
                order: index++,
                propertyName: 'idDepartment',
                propertyType: 'number',
                displayName: 'ID подразделения',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'amountPlan1',
                propertyType: 'number',
                displayName: 'Сумма 1',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'bonusMember1',
                propertyType: 'number',
                displayName: 'Бонус 1',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'amountPlan2',
                propertyType: 'number',
                displayName: 'Сумма 2',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'bonusMember2',
                propertyType: 'number',
                displayName: 'Бонус 2',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'amountPlan3',
                propertyType: 'number',
                displayName: 'Сумма 3',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'bonusMember3',
                propertyType: 'number',
                displayName: 'Бонус 3',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'amountFact',
                propertyType: 'number',
                displayName: 'Факт. сумма выполнения подразделения', //Фактическая сумма выполнения по подразделению
                visibility: true,
                width: 130
            },
            {
                order: index++,
                propertyName: 'bonusFactMember',
                propertyType: 'number',
                displayName: 'Общий факт. бонус',
                visibility: true,
                width: 160
            },
            {
                order: index++,
                propertyName: 'sumAmountPlan',
                propertyType: 'number',
                displayName: 'План сумма (руб)', //План по подразделению в рублях
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'sumQuantityPlan',
                propertyType: 'number',
                displayName: 'План количество (уп.)', //План по подразделению в упаковках
                visibility: true,
                width: 170
            },
            {
                order: index++,
                propertyName: 'sumQuantityFact',
                propertyType: 'number',
                displayName: 'Факт количество (уп.)', //Факт по подразделению в упаковках
                visibility: true,
                width: 170
            },
            {
                order: index++,
                propertyName: 'prcExec',
                propertyType: 'number',
                displayName: 'Процент выполнения',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'bonusPlanMember',
                propertyType: 'number',
                displayName: 'План бонус (руб)', //Плановая сумма бонуса в рублях
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'amountFactRef',
                propertyType: 'number',
                displayName: 'Факт сумма в реф. ценах', //Фактическая сумма в Рефферентных ценах
                visibility: true,
                width: 200
            },
            {
                order: index++,
                propertyName: 'idMarketingEventGlobal',
                propertyType: 'string',
                displayName: 'ID маркетингового мероприятия',
                visibility: false,
                width: 300
            },
            {
                order: index++,
                propertyName: 'deleted',
                propertyType: 'boolean',
                displayName: 'Удален',
                visibility: false,
                width: 100
            },
            {
                order: index++,
                propertyName: 'dateCreated',
                propertyType: 'datetime',
                displayName: 'Дата создания',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateModified',
                propertyType: 'datetime',
                displayName: 'Дата изменения',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateDeleted',
                propertyType: 'datetime',
                displayName: 'Дата удаления',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'idGlobal',
                propertyType: 'string',
                displayName: 'ID',
                visibility: false,
                width: 300
            }
        ];
    })()
};